import { Box, chakra, Flex, Image, Text } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';
import managerChatSketch from 'assets/img/sketches/manager-chat.svg';
import chatEmployeeImage from 'assets/img/thumbnail/chat-employee.jpeg';
import chatFinancialAdvisorImage from 'assets/img/thumbnail/chat-financial-advisor.jpeg';
import { useTranslation } from 'react-i18next';
import { useFetchChatListQuery } from 'rtkQuery/sharespro/queries/chat';
import { ChatRoomType } from 'enums/modules/chat/chatRoomType';
import ChatRoomThumbnail from 'presentation/components/modules/chat/ChatRoomThumbnail';
import { useDispatch } from 'react-redux';
import { widgetChatSlice } from 'slices/modules/chat/widgetChatSlice';

interface Props {
  roomType: ChatRoomType;
}

const PersonalManagerChatCard: FC<Props> = ({ roomType, ...props }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { data: chatListData } = useFetchChatListQuery({ page: 1 });
  const personalManager = chatListData?.chats.items.find(
    (chat) => chat.type === roomType
  );

  if (!personalManager) {
    return null;
  }

  return (
    <AppCard
      cursor="pointer"
      onClick={() => dispatch(widgetChatSlice.actions.open(personalManager))}
      bgGradient="linear(to-br, #F8FCFB 0%, #EDF8F5 100%)"
      border="1px solid"
      borderColor="#CBE9E2"
      boxShadow="inset 0 1px 0 rgba(255, 255, 255, 0.9), inset 0 -2px 5px rgba(42, 62, 92, 0.04)"
      transition="transform 150ms ease"
      _hover={{
        transform: 'translateY(-1px)',
      }}
      p="20px"
      pt="10px"
      {...props}
    >
      <Box>
        <Flex justifyContent="space-between" alignItems="center">
          <ChatRoomThumbnail
            size="62px"
            avatar={
              roomType === ChatRoomType.PersonalManager
                ? chatFinancialAdvisorImage
                : chatEmployeeImage
            }
            roomType={roomType}
          />
          <Box pos="relative">
            <Image src={managerChatSketch} w="62px" />
            {personalManager.unreadMessageCount > 0 && (
              <Box
                pos="absolute"
                bgColor={Color.Danger400}
                right="0"
                top="16px"
                px="8px"
                py="2px"
                borderRadius="10px"
              >
                <Text fontWeight={800} color="#fff">
                  {personalManager.unreadMessageCount}
                </Text>
              </Box>
            )}
          </Box>
        </Flex>
        <Text color={Color.OnSurface} fontWeight={700} mb="2px">
          {roomType === ChatRoomType.PersonalManager
            ? t('chatPersonalManager')
            : t('eventManager')}
        </Text>
      </Box>
    </AppCard>
  );
};

export default chakra(PersonalManagerChatCard);
